<template>
    <template v-if="small">
        <img v-if="small40 && isLegacy" :src="small40" :alt="product.name" :title="product.name" loading="lazy" :class="{'has-dark': product.type === 'Service', 'size-40': 1}">
        <span v-else class="product-no-image-circle size-40 d-block"></span>
    </template>
    <template v-else>
        <div v-if="shouldFlip" class="flip-container">
            <div class="flipper">
                <div class="front">
                    <div v-if="isLegacy" class="image" v-html="img1"></div>
                </div>
                <div class="back">
                    <div v-if="isLegacy" class="image" v-html="img2"></div>
                </div>
            </div>
        </div>
        <template v-else>
            <div v-if="img1 && isLegacy" class="image" v-html="img1"></div>
            <div v-else v-html="imgFallback"></div>
        </template>
    </template>
</template>

<script>
export default {
    computed: {
        shouldFlip() {
            return this.product.is_coin && this.img2;
        },
        isLegacy() {
            return this.product.version === 'legacy';
        },
        small40() {
            if (this.isLegacy) {
                return this.product.images.small ? this.product.images.small : null;
            } else {
                return this.product.images.length ? this.product.images[0].src : null;
            }
        },
        img1() {
            if (this.isLegacy) {
                return this.product.images.main ? this.product.images.main : null;
            } else {
                return this.product.images.length ? this.product.images[0].src : null;
            }
        },
        img2() {
            if (this.isLegacy) {
                return this.product.images.second ? this.product.images.second : null;
            } else {
                return this.product.images.length >= 2 ? this.product.images[1].src : null;
            }
        },
        imgFallback() {
            return this.product.images.fallback ? this.product.images.fallback : null;
        },
        imgHeight() {
            return 'params' in this.product && typeof(this.product.params.height) !== 'undefined' ? this.product.params.height : this.img.height;
        },
        imgPreset() {
            return 'params' in this.product && typeof(this.product.params.preset) !== 'undefined' ? this.product.params.preset : null;
        }
    },
    props: {
        product: {
            type: Object,
            required: true,
        },
        small: {
            type: Boolean,
            default: true,
        },
        img: {
            type: Object,
            default: {
                height: 120,
                width: 120,
            },
        }
    },
};
</script>
